import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=10f434be&"
import script from "./Changelog.vue?vue&type=script&lang=ts&"
export * from "./Changelog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f434be')) {
      api.createRecord('10f434be', component.options)
    } else {
      api.reload('10f434be', component.options)
    }
    module.hot.accept("./Changelog.vue?vue&type=template&id=10f434be&", function () {
      api.rerender('10f434be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/Changelog.vue"
export default component.exports